import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const ListingCountList = styled('ul')(
    () => css`
        display: flex;
        flex-direction: row;
        list-style: none;
        margin: 0;
        padding: 0;
    `
);
